export default __webpack_public_path__ + "static/20-b93d9aa03a494e6e64aba5f97e18b796.jpg";